var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "175px",
    viewBox: "0 0 175 175",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart/icon/vertical-bar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart/icon/vertical-bar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(21.000000, 26.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#B7C140",
    transform: "translate(6.000000, 73.500000) rotate(360.000000) translate(-6.000000, -73.500000) ",
    x: 0,
    y: 24,
    width: 12,
    height: 99,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#243B81",
    transform: "translate(23.000000, 61.500000) rotate(360.000000) translate(-23.000000, -61.500000) ",
    x: 17,
    y: 0,
    width: 12,
    height: 123,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F5A623",
    transform: "translate(41.000000, 68.500000) rotate(360.000000) translate(-41.000000, -68.500000) ",
    x: 35,
    y: 14,
    width: 12,
    height: 109,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#B7C140",
    transform: "translate(58.000000, 88.500000) rotate(360.000000) translate(-58.000000, -88.500000) ",
    x: 52,
    y: 54,
    width: 12,
    height: 69,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#243B81",
    transform: "translate(75.000000, 85.000000) rotate(360.000000) translate(-75.000000, -85.000000) ",
    x: 69,
    y: 47,
    width: 12,
    height: 76,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#D8D8D8",
    transform: "translate(92.000000, 88.000000) rotate(360.000000) translate(-92.000000, -88.000000) ",
    x: 86,
    y: 53,
    width: 12,
    height: 70,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#B7C140",
    transform: "translate(109.000000, 99.500000) rotate(360.000000) translate(-109.000000, -99.500000) ",
    x: 103,
    y: 77,
    width: 12,
    height: 45,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F5A623",
    transform: "translate(127.000000, 85.000000) rotate(360.000000) translate(-127.000000, -85.000000) ",
    x: 121,
    y: 47,
    width: 12,
    height: 76,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBar);
export default __webpack_public_path__ + "static/media/vertical-bar.9e9223ef46f4058bf20aebe0ac0d5a3c.svg";
export { ForwardRef as ReactComponent };